import {notify} from '@gemcook/notification';

import api from '@api';
import constants from '@constants';
import utils from '@utils';
import mappings from '@mappings';
import paths from '@paths';

export const getSelections = (
  mypage: boolean | undefined,
  detail: boolean | undefined,
  authLevel: number | null
) => {
  // 「特権管理者」と「管理者」を表示する
  if (mypage || detail) {
    return utils.mappings.createSelections(mappings.authorities);
  } else if (
    authLevel === constants.AUTHORITIES.ADMIN ||
    authLevel === constants.AUTHORITIES.SUPER_ADMIN
  ) {
    return utils.mappings.createSelections(mappings.authorities);
  }
  // 「一般」と「特権管理者」のみ表示する
  if (authLevel === constants.AUTHORITIES.GENERAL) {
    return utils.mappings.userCreateSelection(mappings.authorities);
  }
};

export const sendSuccessMail = async (
  values: any,
  history: any,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setIsLoading(true);
  try {
    await api.users.sendSuccessMail({
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
    });
    history.push(paths.users.main);
    notify('登録完了メールを送信しました', 'success');
  } catch (error) {
    notify(constants.ERRORS.UNKNWON, 'error');
  } finally {
    setIsLoading(false);
  }
};
